import React from 'react';
import { CommandBarButton, IconButton } from '@fluentui/react';
import DetailsTable from '../../../../Table/DetailsTable';
import FeatureSummary from '../../../../Util/FeatureSummary';

const MonthlyTasksTable = ({
    tasks,
    setSelectedTask,
    setSelectedTaskName,
    loading,
    editOnClick,
    createOnClick,
    previewOnClick,
    deleteOnClick,
}) => {
    const columns = [
        {
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <ContextualMenu
                    editOnClick={editOnClick}
                    previewOnClick={previewOnClick}
                    id={item.themedMonthlyTaskId}
                    item={item}
                    deleteOnClick={deleteOnClick}
                />
            ),
        },
        {
            name: 'Year',
            fieldName: 'year',
            minWidth: 70,
            maxWidth: 100,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Month',
            fieldName: 'month',
            minWidth: 70,
            maxWidth: 100,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Theme Name',
            fieldName: 'themeName',
            minWidth: 150,
            maxWidth: 200,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'International',
            fieldName: 'international',
            minWidth: 100,
            maxWidth: 120,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Article Slug 1',
            fieldName: 'articleSlug1',
            minWidth: 150,
            maxWidth: 200,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Article Slug 2',
            fieldName: 'articleSlug2',
            minWidth: 150,
            maxWidth: 200,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Video Slug',
            fieldName: 'videoSlug',
            minWidth: 150,
            maxWidth: 200,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Infographic Slug',
            fieldName: 'infographicSlug',
            minWidth: 150,
            maxWidth: 200,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Course Slug',
            fieldName: 'courseSlug',
            minWidth: 150,
            maxWidth: 200,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Tool ID 1',
            fieldName: 'toolId1',
            minWidth: 80,
            maxWidth: 100,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Tool ID 2',
            fieldName: 'toolId2',
            minWidth: 80,
            maxWidth: 100,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
    ];

    const items = tasks ?? [];

    const formatLabel = (task) => {
        if (!task) {
            return "";
        }
        if (task.themeName) {
            return task.themeName;
        }
        if (task.month && task.year) {
            return `${task.month}/${task.year}`;
        }
        return String(task.themedMonthlyTaskId ?? "");
    };

    const selectionHook = (items) => {
        const selectedItem = items && items[0];
        setSelectedTask(selectedItem && selectedItem.themedMonthlyTaskId);
        setSelectedTaskName?.(formatLabel(selectedItem));
    };

    return (
        <>
            <DetailsTable
                items={items}
                columns={columns}
                selectionHook={selectionHook}
                loading={loading}
                mainColumn={'name'}
                style={{
                    position: 'relative',
                    height: '80vh',
                    width: '80vw',
                }}
                CommandBar={
                    <CommandBarButton
                        iconProps={{ iconName: 'Edit' }}
                        text="Add Monthly Task"
                        onClick={() => createOnClick()}
                    />
                }
            />
            <FeatureSummary
                label="About Monthly Tasks"
                summary="This table displays all the default monthly tasks, including year, month, theme, and related content. You can add, edit, or delete monthly tasks but deleting a specific month without replacment might cause issues. The Monthly Tasks feature allows default task theme and content to be set for each month. There are international versions too."	
                imageUrlPath='dashboard-monthly-task'
            />
        </>
    );
};

const moreIcon = { iconName: 'More' };

const ContextualMenu = ({ editOnClick, deleteOnClick, id, item, ...rest }) => {
    const buildLabel = () => {
        if (!item) {
            return "";
        }
        if (item.themeName) {
            return item.themeName;
        }
        if (item.month && item.year) {
            return `${item.month}/${item.year}`;
        }
        return String(item.themedMonthlyTaskId ?? "");
    };

    const menuProps = {
        items: [
            {
                key: 'print',
                iconProps: { iconName: 'Edit' },
                text: 'Edit',
                onClick: () => editOnClick(id),
            },
            {
                key: "Delete",
                iconProps: { iconName: "Delete" },
                text: "Delete",
                onClick: () => deleteOnClick(id, buildLabel()),
            },
        ],
    };

    return <IconButton iconProps={moreIcon} menuProps={menuProps} onRenderMenuIcon={() => {}} {...rest} />;
};

export default MonthlyTasksTable;
